"use client";
import { createContext, FC, PropsWithChildren, useContext } from "react";
import {
  getImageComponent,
  getLinkComponent,
  ReactUIConfig,
} from "../../config";

const ReactUIConfigContext = createContext<ReactUIConfig>({});

ReactUIConfigContext.displayName = "ReactUIConfig";

export const useLinkComponent = () =>
  useContext(ReactUIConfigContext).linkComponent ?? getLinkComponent();

export const useImageComponent = () =>
  useContext(ReactUIConfigContext).imageComponent ?? getImageComponent();

const ReactUIProvider: FC<PropsWithChildren<ReactUIConfig>> = ({
  children,
  linkComponent,
  imageComponent,
}) => (
  <ReactUIConfigContext.Provider value={{ linkComponent, imageComponent }}>
    {children}
  </ReactUIConfigContext.Provider>
);

export default ReactUIProvider;
